import React, { useEffect, useState } from "react";
import { BsArrowRight } from "react-icons/bs";
import { FormattedMessage } from "react-intl";
import StyledLink from "../../../shared/StyledLink/StyledLink";
import "./banner.scss";

const Banner = () => {
  const [offset, setOffset] = useState(0);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    function handleScroll() {
      setOffset(window.pageYOffset);
      const scrollHeight = window.pageYOffset;
      setIsSticky(scrollHeight > 20 ? true : false);
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });

  return (
    <div
      className="contact-banner"
      // style={{ transform: `translateY(${offset * -0.5}px)` }}
    >
      <div className="bg"></div>

      <h1 className="big-title">
        <FormattedMessage id="home-banner-title" defaultMessage="Contact Us" />
      </h1>

      <div className="details">
        <div className="col">
          <p className="def-text">
            <FormattedMessage
              id="Emailus"
              defaultMessage="Email Us"
            />
          </p>
          <h1 className="small-title">info@ylliri.com</h1>
        </div>

        <div className="col">
          <p className="def-text">
            <FormattedMessage
              id="Callus"
              defaultMessage="Call Us"
            />
          </p>
          <h1 className="exsmall-title">
            +383 45 111 222
            <p className="def-text">(KS)</p>
          </h1>

          <h1 className="exsmall-title">
            +45 54 29 30 75 <p className="def-text">(DK)</p>
          </h1>
        </div>

        <div className="col">
          <p className="def-text">
            <FormattedMessage
              id="OurLocations"
              defaultMessage="Our Locations"
            />
          </p>
          <p className="def-text">
            <FormattedMessage
              id="contact-banner-details-col3-text"
              defaultMessage="Str. Agim Ramadani, 10000 Prishtinë, Kosovo"
            />
          </p>
          <p className="def-text">
            <FormattedMessage
              id="contact-banner-details-col3-text"
              defaultMessage="Porsevej 3, 6430 Havnbjerg, Sønderborg, Denmark"
            />
          </p>
        </div>
      </div>
    </div>
  );
};
export default Banner;
